import { render } from "./ComplianceImpersonate.vue?vue&type=template&id=0d3f2fbf&scoped=true"
import script from "./ComplianceImpersonate.vue?vue&type=script&lang=js"
export * from "./ComplianceImpersonate.vue?vue&type=script&lang=js"

import "./ComplianceImpersonate.vue?vue&type=style&index=0&id=0d3f2fbf&lang=scss"
import "./ComplianceImpersonate.vue?vue&type=style&index=1&id=0d3f2fbf&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3f2fbf"]])

export default __exports__